<template>
    <span>Redirecting...</span>
</template>

<script>
import Vue from 'vue';

export default ({
  created() {
    console.log('Redirecting to Outseta...');
    window.location.href = 'https://giraffepad.outseta.com/support/kb#/articles/GEWB2OWr/giraffepad-privacy-policy';
  },
});
</script>
